import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Swal from 'sweetalert2';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { ActionLog } from '../Insights';
import { addInsightAction } from '../../../store/ai2';
import InsightItemForm from './InsightItemForm';
import { useInsights } from './hooks/useInsights';

import redBellIcon from '../../../assets/img/redBell.png';
import yellowBellIcon from '../../../assets/img/yellowBell.png';

function CustomToggle({ eventKey }) {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    setIsExpanded(!isExpanded);
  });

  return (
    <div onClick={() => decoratedOnClick()}>
      <span className="arrowCollapse" style={{ marginRight: 10 }}>
        <i
          className={`fa-solid fa-chevron-${isExpanded ? 'up' : 'down'} fa-lg`}
        ></i>
      </span>
    </div>
  );
}

function InsightItemComponent() {
  const { insights, lastUpdatedInsight } = useSelector(
    (state) => state.insights,
  );
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);
  const dispatch = useDispatch();
  const { handleSubmitInsight } = useInsights();

  const handleInsightSubmit = async (action) => {
    const success = await handleSubmitInsight(action);
    if (success) {
      Swal.fire({
        icon: 'success',
        title: 'Action has been saved',
        showConfirmButton: true,
      });
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'You must select an action',
        showConfirmButton: true,
      });
    }
  };

  const handleCloseInsight = async (event, action) => {
    event.preventDefault();
    action.action_status = 'C';
    const queryParams = new URLSearchParams(window.location.search);
    action.access_token = queryParams.get('access_token');
    dispatch(addInsightAction(action, selectedTenancy));
    Swal.fire({
      icon: 'success',
      title: 'Action has been closed',
      showConfirmButton: true,
    });
  };

  const handleCancel = (event) => {
    event.preventDefault();
  };

  const formatDateString = (dateString) => {
    return dateString ? moment(new Date(dateString)).format('DD MMM YYYY') : '';
  };

  if (insights.length > 0) {
    // Sort Insight by Date
    const insightsSorted = insights
      .slice()
      .sort(
        (a, b) =>
          moment(new Date(b.when_created)) - moment(new Date(a.when_created)),
      );

    return (
      <div>
        <h2 className="heading2 mt3">Current insights</h2>
        <Accordion
          id="currentInsights"
          defaultActiveKey={lastUpdatedInsight}
          alwaysOpen
        >
          {insightsSorted.map(
            (item, index) =>
              item.action_status === null ? (
                <Accordion.Item
                  key={index}
                  eventKey={item.id}
                  className={
                    'insight-border ' +
                    (item.risk_status === 'h' ? 'red' : 'yellow')
                  }
                >
                  <Accordion.Header>
                    <CustomToggle eventKey={item.id} />
                    <div>
                      {item?.risk_status === 'h' && (
                        <img
                          className="mr-15"
                          src={redBellIcon}
                          alt="Red Bell"
                        />
                      )}
                      {item?.risk_status !== 'h' && (
                        <img
                          className="mr-15"
                          src={yellowBellIcon}
                          alt="Yellow Bell"
                        />
                      )}
                    </div>
                    <div className="txtinsightDescription">
                      {item.why_created}
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="mb-4">
                      <label className="labelGrey labelBold">
                        {['E', 'A', 'D', 'C', 'S'].includes(item.action_status)
                          ? 'Closed'
                          : item.action_status === null
                            ? 'Ongoing'
                            : item.action_status === 'I'
                              ? 'Ignored'
                              : 'no data'}
                      </label>
                      <label className="labelGrey labelSimple paddingLeft20">
                        {formatDateString(item.when_created)} -{' '}
                        {formatDateString(item.when_ended)}
                      </label>
                    </div>
                    <div className="row mb-4">
                      <div className="col-3">
                        {/*<SummaryLog item={item} />*/}
                      </div>
                      <div className="col-4">
                        <ActionLog item={item} />
                      </div>
                      <div className="col-5">
                        <InsightItemForm
                          item={item}
                          handleInsightSubmit={handleInsightSubmit}
                          handleCloseInsight={handleCloseInsight}
                          handleCancel={handleCancel}
                        />
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ) : null, // This will not render anything if the condition is not met.
          )}
        </Accordion>
      </div>
    );
  } else {
    return null;
  }
}

export { InsightItemComponent };
